import moment from 'moment-timezone';
import { omit } from 'lodash';

import { FORM } from '../../constants';
import { ParcelHelpers } from '../../helpers';

export const isMissingFlow = issueType =>
  issueType === FORM.ISSUE_TYPES.MISSING_CONTENTS;

export const isDamagedFlow = issueType =>
  issueType === FORM.ISSUE_TYPES.DAMAGED;

export const isNotArrivedFlow = issueType =>
  issueType === FORM.ISSUE_TYPES.NOT_ARRIVED;

export const isClaimInvalid = (deliveredDate, daysLimitForClaimProcessing) => {
  const currentDate = moment();

  return (
    deliveredDate &&
    currentDate.diff(deliveredDate, 'days') > daysLimitForClaimProcessing
  );
};

export const getClaimData = (values, parcel) => ({
  ...(parcel?.parcelCode ? { parcelCode: parcel.parcelCode } : {}),
  ...values,
});

export const normalizeClaimData = data => ({
  ...omit(
    data,
    'parcelNumber',
    'helpType',
    'postcodeOrOrderId',
    'contactUsType'
  ),
  // removing currency symbol from goodsValue
  ...(data.goodsValue ? { goodsValue: data.goodsValue.substring(1) } : {}),
  ...(data.postcodeOrOrderId
    ? ParcelHelpers.getPostcodeOrOrderId(data.postcodeOrOrderId)
    : {}),
  reasonForContact: data.reasonForContact || data.contactUsType,
  attachedImages: Array.isArray(data.attachedImages)
    ? data.attachedImages.map(image => ({
        image: image.image,
        fileName: image.fileName,
        contentType: image.contentType,
      }))
    : [],
});
